<button *ngIf="options.closeButton" (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
  <span aria-hidden="true">&times;</span>
</button>
<button
  *ngIf="showCopyButton"
  type="button"
  class="toast-copy-button"
  [attr.aria-label]="copied ? 'Copied' : 'Copy message'"
  [title]="copied ? 'Copied' : 'Copy message'"
  (click)="copyMessage($event)"
>
  <span class="material-icons" aria-hidden="true">{{ copied ? 'check' : 'content_copy' }}</span>
</button>
<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
  {{ title }} <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
</div>
<!-- Do not bind multi-line message to aria-label — browsers truncate at the first newline. -->
<ng-container *ngIf="message">
  <div
    #toastMessageEl
    *ngIf="options.enableHtml; else plainMessage"
    role="alert"
    [class]="options.messageClass"
    [innerHTML]="message"
  ></div>
  <ng-template #plainMessage>
    <div #toastMessageEl role="alert" [class]="options.messageClass">{{ message }}</div>
  </ng-template>
</ng-container>
<div *ngIf="options.progressBar">
  <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
